import React from "react";
import axios from "axios";
import swal from "sweetalert2";

const SgbCancelModel = ({
  setCancelModalFlag,
  cancelModalData,
  setCancelModalData,
}) => {
  const clientCode = JSON.parse(localStorage.getItem("clientCode"));
  const token = JSON.parse(localStorage.getItem("token"));

  const fetchData = async (apiEndpoint, setDataFunction, data, url) => {
    debugger;
    $("#CRloader").show();
    try {
      const response = await axios.post(`${url}${apiEndpoint}`, data, {
        headers: {
          "Content-Type": "application/json",
          token: token,
          clientcode: clientCode,
          applicationname: "SGB",
        },
      });

      let newData = await response.data;
      if (newData.Table1) {
        newData = await response.data.Table1;
      }
      // debugger;
      newData = JSON.parse(newData);

      $("#CRloader").hide();

      new swal({
        title: "Success",
        text: `Order no.${newData.orderNumber} is sent for cancellation`,
        icon: "success",
        button: "OK",
      }).then(() => {
        window.location.reload();
      });
    } catch (error) {
      //console.log("error while fetching", error);
    }
  };

  const handleCancelsgb = () => {
    debugger;
    const orderparams = {
      symbol: cancelModalData.SYMBOL,
      orderNumber: cancelModalData.ORDERNUMBER,
      price: cancelModalData.PRICE,
      quantity: cancelModalData.QUANTITY,
      physicalDematFlag: cancelModalData.PHYSICALDEMATFLAG,
      clientCode: cancelModalData.CLIENTCODE,
      pan: cancelModalData.PANNO,
      depository: cancelModalData.DEPOSITORY,
      dpID: cancelModalData.DPID,
      clientBenId: cancelModalData.CLIENTBENID,
      clientRefNumber: cancelModalData.CLIENTREFNUMBER,
      activityType: "CR",
    };
    fetchData(
      "SGB/Order_Master",
      null,
      orderparams,
      process.env.REACT_APP_APIURL
    );
    setCancelModalFlag(false);
  };

  const HandleModalClose = () => {
    setCancelModalFlag(false);
    //console.log("modal data before cancle,", cancelModalData);
    setCancelModalData(null);
  };

  return (
    // <div class="pop_section" id="confirm_cancellation">
    <div class="pop_inner">
      <i
        class="close_add click_4"
        onClick={() => {
          HandleModalClose();
        }}
      >
        X
      </i>
      <h3>Confirm Cancellation</h3>
      <p>
        <b>Series: GB</b>
      </p>
      <p>
        <b>Rate: ₹ {cancelModalData.PRICE ? cancelModalData.PRICE : "RATE"}</b>
      </p>
      <p>
        <b>
          QTY:{" "}
          {cancelModalData.QUANTITY ? cancelModalData.QUANTITY : "QUANTITY"}
        </b>
      </p>
      <p>
        <b>
          Amount: ₹
          {cancelModalData.QUANTITY
            ? cancelModalData.QUANTITY * cancelModalData.PRICE
            : "QUANTITY"}
        </b>
      </p>
      <p>
        <b>
          Last Date:{" "}
          {cancelModalData.LASTACTIONTIME
            ? cancelModalData.LASTACTIONTIME
            : "21-12-2023"}
        </b>
      </p>
      <p>
        <b>Interest received per annum: </b>{" "}
        {(cancelModalData.PRICE * (cancelModalData.INTERESTRATE / 100)).toFixed(
          3
        )}
        /gm <b>({cancelModalData.INTERESTRATE}% of the issue price)</b>
      </p>
      <p>
        <b>Interest received Interval: </b> Half Yearly{" "}
      </p>
      <p>
        <b>
          Issue Price: {cancelModalData.PRICE ? cancelModalData.PRICE : " RATE"}
        </b>
      </p>
      <button
        className="apply_now click_cancel_order"
        onClick={() => {
          handleCancelsgb();
        }}
      >
        Cancel
      </button>
    </div>
    // </div>
  );
};

export default SgbCancelModel;
